import styled, { css } from 'styled-components';

export const StyledTabs = styled.div`
  display: flex;
  width: 100%;
`;

export const StyledTab = styled.button<{
  selected?: boolean;
  hover: boolean;
  disabled?: boolean;
}>`
  display: flex;
  align-items: center;
  position: relative;
  cursor: pointer;
  width: unset;
  min-width: unset;
  flex: 1 1 0px;
  background-color: ${({ theme }) => theme.palette.lynxWhite};
  padding: 20px 0;
  justify-content: center;
  color: ${({ theme }) => theme.palette.coral};
  font-size: 16px;
  font-weight: ${(props) => (props.selected ? 'bold' : 'normal')};
  border: none;
  border-bottom: solid 4px
    ${({ selected, theme }) =>
      selected ? theme.palette.tomato : theme.palette.lightBlueGrey};

  ${(p) =>
    p.disabled
      ? css`
          background: ${({ theme }) => theme.palette.lightBlueGrey};
          color: ${({ theme }) => theme.palette.lightGray};
          pointer-events: none;
        `
      : null}
  ${(p) =>
    p.selected
      ? css`
          &:after {
            border-right: solid 7px transparent;
            border-left: solid 7px transparent;
            border-top: solid 7px ${({ theme }) => theme.palette.tomato};
            transform: translateX(-50%);
            position: absolute;
            content: '';
            bottom: -15%;
            left: 50%;
            height: 0;
            width: 0;
            z-index: 5;
          }
        `
      : null}
`;

export const TabText = styled.span<{ isSelected?: boolean }>`
  padding-left: 5px;
  & span {
    white-space: nowrap;
  }
`;
